import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { TextField, BaseTextFieldProps } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import '../../hmilib/hmiglobal';
import '../../hmilib/hmiglobal';
import TimelineIcon from '@mui/icons-material/Timeline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventIcon from '@mui/icons-material/Event';

interface iTopMenu {}

const TopMenu = (props: iTopMenu) => {
    const [nameUnit, setnameUnit] = React.useState('');

    ///Для подсветки меню
    function eventHandlerOpenMnemo(e: any) {
        let name = (e.detail.name as string).toLowerCase();

        /*
        let activelem = document.querySelector(".webelement-nav-panel-left .tab.active");
        if (activelem != null) {
            activelem.classList.remove("active");
        }

        if (name == "alarms") {
            let activelem = document.querySelector(".webelement-nav-panel-left .alarm");
            if (activelem != null) {
                activelem.classList.add("active");
            }
        } else if (name == "trends") {
            let activelem = document.querySelector(".webelement-nav-panel-left .trend");
            if (activelem != null) {
                activelem.classList.add("active");
            }
        } */

        if (window.BeforeMnemoList.length >= 1) {
            document.querySelector('.webelement-nav-panel-left .before')?.classList.add('active');
        } else {
            document.querySelector('.webelement-nav-panel-left .before')?.classList.remove('active');
        }
    }

    function EventSelectedMenuItem(event: any) {
        let name = event.detail.name;

        if (name != 'Мнемосхемы') {
            setnameUnit(name);
        }
    }

    React.useEffect(() => {
        document.addEventListener('OpenMnemoFile', eventHandlerOpenMnemo);
        window.addEventListener('EventSelectedMenuItem', EventSelectedMenuItem);

        return () => {
            document.removeEventListener('OpenMnemoFile', eventHandlerOpenMnemo);
            window.removeEventListener('EventSelectedMenuItem', EventSelectedMenuItem);
        };
    }, []);

    return (
        <div className="webelement-nav-panel">
            <div className="webelement-nav-panel-left">
                <Button
                    className="tab before"
                    style={{ display: 'none', minWidth: '3.08rem' }}
                    onClick={() => {
                        window.BeforeMnemo();
                    }}
                    title="Предыдущая схема">
                    <ArrowBackIcon />
                </Button>
                <Button
                    className="tab trend active"
                    style={{ minWidth: '3.08rem' }}
                    onClick={() => {
                        window.OpenMnemo('trends');
                    }}
                    title="Тренды">
                    <TimelineIcon />
                </Button>
                <Button
                    className="tab alarm active"
                    style={{ minWidth: '3.08rem' }}
                    onClick={() => {
                        window.OpenMnemo('alarms');
                    }}
                    title="События">
                    <EventIcon />
                </Button>
            </div>
            <div className="webelement-nav-panel-centr">
                {' '}
                <div></div>
            </div>
            <div className="webelement-nav-panel-right"></div>
        </div>
    );
};

export default TopMenu;
